import React, { useRef } from "react";

import "./Join.css";

const Join = () => {
  const form = useRef();
  return (
    <div className="Join" id="join-us">
      <div className="left-j">
        <hr />
        <div>
          <span className="stroke-text">READY TO</span>
          <span> LEVEL UP</span>
        </div>
        <div>
          <span>YOUR BODY</span>
          <span className="stroke-text"> WITH US ?</span>
        </div>
      </div>
      <div className="right-j">
        <form autoComplete="off" ref={form} className="email-container">
          <input
            autocomplete="false"
            type="text"
            name="user_email"
            placeholder="Enter your email"
          />
          <button className="btn btn-j" onClick={()=>{window.open("mailto:pro39gym@gmail.com")}}>Join Now</button>
        </form>
      </div>
    </div>
  );
};

export default Join;
